import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/config/api";

export const useScheduleCategoryStore = defineStore("scheduleCategory", {
  state: () => ({
    categories: [],
    loaded: false,
    isLoading: false,
    error: null,
  }),

  getters: {
    // [{ CATEGORY_CDV, CATEGORY_NMV, ICON_NMV, SORT_ORDER }, ...]
    categoryList: (state) => state.categories,

    // { car: "車", train: "電車", ... }
    cdvToName: (state) => {
      const map = {};
      state.categories.forEach((c) => {
        map[c.CATEGORY_CDV] = c.CATEGORY_NMV;
      });
      return map;
    },

    // { car: "car-solid", train: "train-subway-solid-full", ... }
    cdvToIcon: (state) => {
      const map = {};
      state.categories.forEach((c) => {
        if (c.ICON_NMV) map[c.CATEGORY_CDV] = c.ICON_NMV;
      });
      return map;
    },
  },

  actions: {
    async fetchCategories() {
      if (this.loaded) return;
      this.isLoading = true;
      try {
        const { data } = await axios.get(
          `${API_URL}/master/schedule-categories`,
        );
        this.categories = data.map((category) =>
          category.CATEGORY_CDV === "movement"
            ? { ...category, CATEGORY_NMV: "移動" }
            : category,
        );
        this.loaded = true;
      } catch (err) {
        this.error = err;
        console.error("スケジュールカテゴリ取得エラー:", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
